import { ContractListApp } from "document/list/app";
import { DocumentTotalsApp } from "documenttotals/DocumentTotalsApp";
import DocumentV1CopyApp from "documentV1/copy/App";
import DocumentV1DetailApp from "documentV1/detail/App";
import DocumentV1NewApp from "documentV1/new/App";
import {
  type RouteObject,
} from "react-router";


declare let viewModel: any;

export const contractRoute: RouteObject = {
  children: [{
    index: true,
    path: "contract",
    loader: () => viewModel,
    Component: ContractListApp,
  }, {
    path: "contract/total",
    loader: () => ({ viewModel, documentType: "contract" }),
    Component: DocumentTotalsApp,
  }, {
    path: "contract/new",
    loader: () => viewModel,
    Component: DocumentV1NewApp,
  }, {
    path: "contract/detail/:documentId",
    loader: () => viewModel,
    Component: DocumentV1DetailApp,
  }, {
    path: "contract/copy/:documentId",
    loader: () => viewModel,
    Component: DocumentV1CopyApp,
  }]
};